import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  className: "upload"
};
const _hoisted_2 = ["src"];
import { upload_pic } from "@/api/index";

import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: /*@__PURE__*/_mergeModels(['change'], ["update:modelValue"]),
  setup(__props, {
    emit: __emit
  }) {
    const url = _useModel(__props, "modelValue");
    const emit = __emit;
    const fileInput = async e => {
      let list = ['image/jpeg', 'image/png', "image/jpg"];
      const file = e.target.files[0];
      const maxSize = 2 * 1024 * 1024; //限制30M
      if ((file === null || file === void 0 ? void 0 : file.size) > maxSize) {
        showToast('文件大小不得超过2M');
        return;
      }
      if (!list.includes(file.type)) {
        showToast('上传头像图片格式不正确');
        return;
      }
      try {
        const formData = new FormData();
        formData.append('picFile', file);
        const avatar = await upload_pic(formData);
        emit('change', avatar);
      } catch (error) {
        console.log(error);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        className: "upload-avatar",
        src: url.value
      }, null, 8, _hoisted_2), _createElementVNode("input", {
        className: "upload-input",
        type: "file",
        id: "file-input",
        onInput: fileInput
      }, null, 32)]);
    };
  }
};